(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["media-card"] && !Shopify.designMode) return;
  try {
    class MediaCardPause extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      const { signal } = this._controller;

      const video = this.closest('.media-card')?.querySelector('.media-card__background video');
      if (!video) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        if (!video.paused) video.pause();
      }

      this.addEventListener('click', () => this._toggle(video), { signal });

      video.addEventListener('play', () => this._setPressed(false), { signal });
      video.addEventListener('pause', () => this._setPressed(true), { signal });

      this._setPressed(video.paused);
    }

    disconnectedCallback() {
      this._controller?.abort();
    }

    _toggle(video) {
      if (video.paused) {
        video.dataset.userPlayed = 'true';
        video.play();
      } else {
        delete video.dataset.userPlayed;
        video.pause();
      }
    }

    _setPressed(paused) {
      const btn = this.querySelector('button');
      btn.setAttribute('aria-pressed', String(paused));
      btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }
  }

  if (!customElements.get('media-card-pause')) {
    customElements.define('media-card-pause', MediaCardPause);
  }

  document.addEventListener('click', (e) => {
    const card = e.target.closest('.media-card');
    if (!card || e.target.closest('a, button')) return;
    card.querySelector('.action-bar a')?.click();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-virtual-variant-selector"] && !Shopify.designMode) return;
  try {
    class PdpVirtualVariantSelector extends HTMLElement {
    #controller = null;
    #isAdding = false;

    connectedCallback() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      const { signal } = this.#controller;

      const scope = this.closest('product-form-component');
      const select = this.querySelector('[data-vv-select]');

      if (select) {
        this.#onSelectChange();
        select.addEventListener('change', () => this.#onSelectChange(), { signal });
      }

      scope?.querySelector('[ref="addToCartButton"]')
        ?.addEventListener('click', () => this.#addToCart(), { signal });
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }

    #onSelectChange() {
      const scope = this.closest('product-form-component');
      const btn = scope?.querySelector('[ref="addToCartButton"]');
      const select = this.querySelector('[data-vv-select]');
      const selectedOption = select?.options[select.selectedIndex];
      const soldOut = !!selectedOption?.disabled;

      if (btn) btn.disabled = soldOut;

      const textEl = btn?.querySelector('[data-add-to-cart-text] > span > span');
      if (textEl) {
        textEl.textContent = soldOut
          ? (this.dataset.soldOutText ?? '')
          : (this.dataset.addToCartText ?? '');
      }

      const qtyComp = scope?.querySelector('quantity-selector-component');
      if (qtyComp) soldOut ? qtyComp.disable() : qtyComp.enable();

      this.#updatePrice(selectedOption);
      this.#updateMedia(selectedOption);
    }

    #updatePrice(option) {
      if (!option) return;
      const section = this.closest('section');
      for (const priceEl of section?.querySelectorAll('[data-pdp-price]') ?? []) {
        const span = priceEl.querySelector('.price');
        if (span) span.textContent = option.dataset.formattedPrice;
      }
    }

    #updateMedia(option) {
      const targetMediaId = option?.dataset.vvImageTargetId;
      const hasImageTarget = this.querySelector('[data-vv-image-target-id]');
      if (!targetMediaId && !hasImageTarget) return;

      const carousel = this.closest('section')?.querySelector('pdp-media-carousel');
      if (!carousel || typeof carousel.goTo !== 'function') return;
      if (!targetMediaId) {
        carousel.goTo(0);
        return;
      }

      const slide = carousel.querySelector(`[data-media-id="${targetMediaId}"]`);
      if (!slide) return;

      carousel.goTo(parseInt(slide.dataset.index, 10));
    }

    #addToCart() {
      if (this.#isAdding) return;

      const select = this.querySelector('[data-vv-select]');
      const selectedOption = select?.options[select.selectedIndex];
      if (!selectedOption?.value || selectedOption.disabled) return;

      let parsedItems;
      try {
        parsedItems = JSON.parse(selectedOption.dataset.items ?? '[]');
      } catch {
        return;
      }
      if (!Array.isArray(parsedItems) || !parsedItems.length) return;

      const scope = this.closest('product-form-component');
      const qtyComp = scope?.querySelector('quantity-selector-component');
      const quantity = Math.max(1, parseInt(qtyComp?.getValue() ?? '1', 10) || 1);

      const btn = scope?.querySelector('[ref="addToCartButton"]');
      if (!btn) return;

      this.#isAdding = true;

      const items = parsedItems.map((item) => ({ ...item, quantity }));

      scope?.addItems(items)
        ?.catch(console.error)
        ?.finally(() => { this.#isAdding = false; });
    }
  }

  if (!customElements.get('pdp-virtual-variant-selector')) {
    customElements.define('pdp-virtual-variant-selector', PdpVirtualVariantSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["responsive-video-bg"] && !Shopify.designMode) return;
  try {
    class ResponsiveVideoBg extends HTMLElement {
    #mq = window.matchMedia('(max-width: 749px)');
    #observer = null;
    #controller = null;
    #visible = false;

    connectedCallback() {
      this.#controller = new AbortController();
      const { signal } = this.#controller;

      this.#loadForViewport();
      this.#mq.addEventListener('change', () => this.#loadForViewport(), { signal });

      this.#observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          this.#visible = entry.isIntersecting;
          const video = this.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting) {
            if (video.currentSrc) video.play().catch(() => {});
          } else {
            video.pause();
          }
        }
      });

      this.#observer.observe(this);
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#observer?.disconnect();
    }

    #loadForViewport() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const video = this.querySelector('video');
      if (!video) return;

      const hasMobile = video.querySelector('source[data-bp="mobile"]') !== null;
      const active = hasMobile && this.#mq.matches ? 'mobile' : 'desktop';

      for (const source of video.querySelectorAll('source[data-bp]')) {
        if (source.dataset.bp === active) {
          source.setAttribute('src', source.dataset.src);
        } else {
          source.removeAttribute('src');
        }
      }

      video.load();

      if (this.#visible) video.play().catch(() => {});
    }
  }

  if (!customElements.get('responsive-video-bg')) {
    customElements.define('responsive-video-bg', ResponsiveVideoBg);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["storytelling-card"] && !Shopify.designMode) return;
  try {
    class StorytellingCard extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('.storytelling-card__video');
      if (!video || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.#observer = new IntersectionObserver((entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setTimeout(() => {
              video.play();
            }, 1000);
            obs.disconnect();
          }
        }
      }, { threshold: 0.75 });

      this.#observer.observe(this);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }

    #observer = null;
  }

  customElements.define('storytelling-card', StorytellingCard);
  } catch(e) { console.error(e); }
})();

})();
